(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6056],{

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34031);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15818);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/breadcrumb.tsx




// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    listProps,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = cx("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list",
    ...listProps,
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.list
    }
  }, clones)));
});
Breadcrumb.displayName = "Breadcrumb";

// src/breadcrumb-item.tsx



// src/breadcrumb-separator.tsx

var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

// src/breadcrumb-link.tsx

var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: cx("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = cx("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
BreadcrumbItem.displayName = "BreadcrumbItem";



/***/ }),

/***/ 57026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15818);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54520);
// ../../../react-shim.js


// src/select.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx


// src/select-field.tsx

var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: cx("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
SelectField.displayName = "SelectField";

// src/select.tsx
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  var _a;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = split(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = {
    paddingEnd: "2rem",
    ...styles.field,
    _focus: {
      zIndex: "unset",
      ...(_a = styles.field) == null ? void 0 : _a["_focus"]
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": dataAttr(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
Select.displayName = "Select";
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
SelectIcon.displayName = "SelectIcon";



/***/ }),

/***/ 58362:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent",
      function () {
        return __webpack_require__(70743);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57026);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);





function InputSelectGroup(param) {
    let { name , label , placeholder , description , options , control , rules , watch , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .Controller */ .Qr, {
        control: control,
        render: (param)=>{
            let { field: { onChange , value  } , formState: { errors  }  } = param;
            var _get, _get1, _get2, _get3;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .FormControl */ .NI, {
                isInvalid: ((_get = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(errors, name)) === null || _get === void 0 ? void 0 : _get.message) !== "" && ((_get1 = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(errors, name)) === null || _get1 === void 0 ? void 0 : _get1.message) !== undefined,
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .FormLabel */ .lX, {
                        mb: 1,
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Select */ .Ph, {
                        ...rest,
                        name: name,
                        id: name,
                        value: value || "",
                        onChange: onChange,
                        placeholder: placeholder,
                        _placeholder: {
                            color: "gray.300"
                        },
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Center */ .M5, {
                            width: "16px !important",
                            height: "10px !important",
                            mr: -2,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "/image-icon/dropdown.png",
                                width: 16,
                                height: 10,
                                alt: "dropdown"
                            })
                        }),
                        children: options.map((option)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: option.value,
                                children: option.label
                            }, option.value))
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .FormHelperText */ .Q6, {
                        children: description
                    }),
                    ((_get2 = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(errors, name)) === null || _get2 === void 0 ? void 0 : _get2.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .FormErrorMessage */ .J1, {
                        mt: 1,
                        children: (_get3 = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(errors, name)) === null || _get3 === void 0 ? void 0 : _get3.message
                    })
                ]
            });
        },
        name: name,
        rules: rules
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (InputSelectGroup);


/***/ }),

/***/ 64070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_header_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var dist_index_esm = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/breadcrumb/AppBreadcrumb.tsx





function AppBreadcrumb(param) {
    let { breadcrumb  } = param;
    // use router
    const { pathname  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Breadcrumb */.aG, {
            separator: ">",
            color: "gray.600",
            className: "app-breadcrumb",
            children: breadcrumb.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbItem */.gN, {
                    isCurrentPage: pathname === item.href,
                    children: item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.href,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbLink */.At, {
                            children: item.label
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        noOfLines: 1,
                        children: item.label
                    })
                }, index))
        })
    });
}
/* harmony default export */ var breadcrumb_AppBreadcrumb = (AppBreadcrumb);

;// CONCATENATED MODULE: ./components/page-header/PageHeader.tsx




function PageHeader(param) {
    let { title , breadcrumb , backLink , containerMaxWidth ="850px"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderColor: "primary.400",
                pt: 8,
                pb: 4,
                bgGradient: "linear(to-t, white 55%, #ffd5b1 100%)",
                display: {
                    base: "none",
                    lg: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    maxWidth: containerMaxWidth,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "lg",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            fontSize: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                                breadcrumb: breadcrumb
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: 2,
                display: {
                    base: "block",
                    lg: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "md",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                            breadcrumb: breadcrumb
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var page_header_PageHeader = (PageHeader);


/***/ }),

/***/ 61053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





function PageTitleMobile(param) {
    let { children , backLink  } = param;
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        bg: "#F36621",
        height: "32px",
        display: {
            lg: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            h: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
                color: "white",
                h: "100%",
                children: [
                    backLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                        variant: "unstyled",
                        minW: "auto",
                        minHeight: "auto",
                        onClick: ()=>{
                            router.push(backLink, backLink, {
                                locale: router.locale
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/image-icon/arrow-prev-white.png",
                            width: 9,
                            height: 12,
                            alt: "next"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        fontSize: "17px",
                        fontWeight: "400",
                        color: "white",
                        children: children
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitleMobile);


/***/ }),

/***/ 46788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProvince; }
/* harmony export */ });
/* harmony import */ var interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68856);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49770);


function useProvince() {
    const { data: provinces  } = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        url: "".concat("https://api.lamptan.co.th", "/v1/public/provinces"),
        method: "GET"
    });
    const region = Object.values(interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum */ .h).map((region)=>{
        let regionNameTh = "";
        switch(region){
            case interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum.BANGKOK_METROPOLIS */ .h.BANGKOK_METROPOLIS:
                regionNameTh = "กรุงเทพฯและปริมณฑล";
                break;
            case interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum.NORTHERN */ .h.NORTHERN:
                regionNameTh = "ภาคเหนือ";
                break;
            case interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum.NORTHEASTERN */ .h.NORTHEASTERN:
                regionNameTh = "ภาคตะวันออกเฉียงเหนือ";
                break;
            case interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum.CENTRAL */ .h.CENTRAL:
                regionNameTh = "ภาคกลาง";
                break;
            case interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum.SOUTHERN */ .h.SOUTHERN:
                regionNameTh = "ภาคใต้";
                break;
            case interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum.WESTERN */ .h.WESTERN:
                regionNameTh = "ภาคตะวันตก";
                break;
            case interfaces_provice_interface__WEBPACK_IMPORTED_MODULE_0__/* .ThailandRegionEnum.EASTERN */ .h.EASTERN:
                regionNameTh = "ภาคตะวันออก";
                break;
            default:
                regionNameTh = "NA";
                break;
        }
        return {
            name: regionNameTh,
            value: region
        };
    });
    return {
        provinces: provinces,
        region: region
    };
}


/***/ }),

/***/ 68856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ThailandRegionEnum; }
/* harmony export */ });
var ThailandRegionEnum;
(function(ThailandRegionEnum) {
    ThailandRegionEnum["BANGKOK_METROPOLIS"] = "BANGKOK_METROPOLIS";
    ThailandRegionEnum["NORTHERN"] = "NORTHERN";
    ThailandRegionEnum["NORTHEASTERN"] = "NORTHEASTERN";
    ThailandRegionEnum["CENTRAL"] = "CENTRAL";
    ThailandRegionEnum["SOUTHERN"] = "SOUTHERN";
    ThailandRegionEnum["WESTERN"] = "WESTERN";
    ThailandRegionEnum["EASTERN"] = "EASTERN";
})(ThailandRegionEnum || (ThailandRegionEnum = {}));


/***/ }),

/***/ 70743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ agent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
// EXTERNAL MODULE: ./components/inputs/InputSelectGroup.tsx
var InputSelectGroup = __webpack_require__(23542);
// EXTERNAL MODULE: ./components/page-header/PageHeader.tsx + 1 modules
var PageHeader = __webpack_require__(64070);
// EXTERNAL MODULE: ./components/page-header/PageTitleMobile.tsx
var PageTitleMobile = __webpack_require__(61053);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
;// CONCATENATED MODULE: ./components/pages-agent/AgentItem.tsx


function AgentItem(param) {
    let { dealer , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        mb: 2,
        pb: 2,
        borderBottom: "1px solid #999",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                justifyContent: "space-between",
                alignItems: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                                as: "h2",
                                fontSize: "md",
                                fontWeight: 400,
                                mb: 1,
                                onClick: onClick,
                                cursor: "pointer",
                                _hover: {
                                    color: "primary.500"
                                },
                                children: dealer.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "14px",
                                lineHeight: 1.3,
                                children: [
                                    dealer.address,
                                    " ",
                                    dealer.subDistrict,
                                    " ",
                                    dealer.district,
                                    " ",
                                    dealer.province ? dealer.province.name_th : "NA",
                                    " ",
                                    dealer.postalCode
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "14px",
                                lineHeight: 1.3,
                                children: [
                                    "โทร: ",
                                    dealer.phone
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "link",
                            size: "sm",
                            onClick: ()=>{
                                window.open("https://www.google.com/maps/dir/?api=1&destination=".concat(dealer.latitude, ",").concat(dealer.longitude), "_blank");
                            },
                            children: "นำทาง"
                        })
                    })
                ]
            }),
            dealer.externalUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                mt: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                    variant: "link",
                    size: "sm",
                    fontWeight: 300,
                    onClick: ()=>{
                        var _dealer_externalUrl;
                        window.open((_dealer_externalUrl = dealer.externalUrl) === null || _dealer_externalUrl === void 0 ? void 0 : _dealer_externalUrl.toString(), "_blank");
                    },
                    children: dealer.externalUrl
                })
            })
        ]
    });
}
/* harmony default export */ var pages_agent_AgentItem = (AgentItem);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/pages-agent/AgentItemMarker.tsx




function AgentItemMarker(param) {
    let { dealer , showInfoWindow =false , onClick , onInfoWindowClose  } = param;
    const [isLoaded, setIsLoaded] = react.useState(false);
    const [isMarkerClicked, setIsMarkerClicked] = react.useState(false);
    (0,react.useEffect)(()=>{
        setIsLoaded(true);
    }, []);
    (0,react.useEffect)(()=>{
        if (showInfoWindow) {
            setIsMarkerClicked(true);
        }
    }, [
        showInfoWindow
    ]);
    const handleMarkerClick = ()=>{
        setIsMarkerClicked(true);
        onClick(dealer);
    };
    return isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
        position: {
            lat: dealer.latitude,
            lng: dealer.longitude
        },
        onClick: handleMarkerClick,
        children: isMarkerClicked && dealer.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InfoWindow */.nx, {
            position: {
                lat: dealer.latitude,
                lng: dealer.longitude
            },
            onCloseClick: ()=>{
                setIsMarkerClicked(false);
                onInfoWindowClose();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                    children: dealer.name
                })
            })
        })
    }, dealer.id) : null;
}
/* harmony default export */ var pages_agent_AgentItemMarker = (AgentItemMarker);

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./hooks/useDealer.ts

function useDealer(params) {
    const apiUrl = (params === null || params === void 0 ? void 0 : params.queryStringify) ? "".concat("https://api.lamptan.co.th", "/v1/public/dealers?").concat(params.queryStringify) : "".concat("https://api.lamptan.co.th", "/v1/public/dealers");
    const { data , error: docsError , mutate: dataMutate  } = (0,dist/* default */.ZP)(!(params === null || params === void 0 ? void 0 : params.id) ? {
        url: apiUrl,
        method: "GET"
    } : null, {
        revalidateOnFocus: (params === null || params === void 0 ? void 0 : params.revalidateOnFocus) || false
    });
    const { data: doc , error: docError , mutate: docMutate  } = (0,dist/* default */.ZP)((params === null || params === void 0 ? void 0 : params.id) ? {
        url: "".concat("https://api.lamptan.co.th", "/v1/dealers/").concat(params === null || params === void 0 ? void 0 : params.id).concat(params.queryStringify ? "?".concat(params.queryStringify) : ""),
        method: "GET"
    } : null, {
        revalidateOnFocus: (params === null || params === void 0 ? void 0 : params.revalidateOnFocus) || false
    });
    return {
        data,
        doc,
        dataLoading: !docsError && !data,
        docsError,
        docLoading: !docError && !doc,
        docError,
        dataMutate,
        docMutate
    };
}

// EXTERNAL MODULE: ./hooks/useProvince.ts
var useProvince = __webpack_require__(46788);
// EXTERNAL MODULE: ./interfaces/provice.interface.ts
var provice_interface = __webpack_require__(68856);
// EXTERNAL MODULE: ./layouts/RootLayout.tsx + 10 modules
var RootLayout = __webpack_require__(89806);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
;// CONCATENATED MODULE: ./pages/agent.tsx




















const center = {
    lat: 13.736717,
    lng: 100.523186
};
const libraries = [
    "places",
    "marker",
    "maps"
];
const AgentPage = ()=>{
    const [isTablet] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 768px)");
    const [isDesktop] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 1024px)");
    const { control , watch , setValue  } = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
        defaultValues: {
            region: provice_interface/* ThailandRegionEnum.BANGKOK_METROPOLIS */.h.BANGKOK_METROPOLIS,
            province: "1"
        }
    });
    const [queryObject, setQueryObject] = (0,react.useState)({
        page: 1,
        limit: 1000,
        include: [
            "province"
        ],
        where: undefined
    });
    const { data: dealersData , dataLoading: dealersDataLoading , dataMutate  } = useDealer({
        revalidateOnFocus: true,
        queryStringify: query_string.stringify(queryObject)
    });
    const { data: dealerProvinces  } = (0,dist/* default */.ZP)("".concat("https://api.lamptan.co.th", "/v1/public/dealers/provinces"));
    ;
    const { provinces , region: regions  } = (0,useProvince/* default */.Z)();
    const { data: dealerShopData  } = (0,dist/* default */.ZP)("".concat("https://api.lamptan.co.th", "/v1/public/dealers/shops"));
    ;
    const regionFormValues = watch("region");
    const provinceFormValues = watch("province");
    const [currentDealer, setCurrentDealer] = (0,react.useState)(null);
    const { isLoaded  } = (0,esm/* useJsApiLoader */.Ji)({
        id: "google-map-script",
        googleMapsApiKey: "AIzaSyBhtP1-PVOxLuSLwvat57bBpchG2a2CCCM",
        libraries: libraries
    });
    const [map, setMap] = (0,react.useState)(null);
    const [currentRegionProvinces, setCurrentRegionProvinces] = (0,react.useState)([]);
    const onLoad = (0,react.useCallback)(function callback(map) {
        map.setZoom(14);
        setMap(map);
    }, []);
    const onUnmount = (0,dist_index_esm/* useCallbackRef */.W6)(function callback(map) {
        setMap(null);
    }, []);
    (0,react.useEffect)(()=>{
        if (provinces && regionFormValues && map) {
            const _currentRegion = dealerProvinces === null || dealerProvinces === void 0 ? void 0 : dealerProvinces.find((province)=>province.region === regionFormValues);
            setCurrentRegionProvinces((_currentRegion === null || _currentRegion === void 0 ? void 0 : _currentRegion.provinces) || []);
            if (_currentRegion && _currentRegion.provinces.length > 0) {
                setValue("province", _currentRegion.provinces[0].id.toString());
            } else {
                setValue("province", "");
            }
        }
    }, [
        dealerProvinces,
        regionFormValues,
        setValue,
        map
    ]);
    (0,react.useEffect)(()=>{
        if (provinceFormValues && currentRegionProvinces) {
            setQueryObject((prev)=>({
                    ...prev,
                    where: "provinceId|in|" + provinceFormValues
                }));
        } else {
            setQueryObject((prev)=>({
                    ...prev,
                    where: undefined
                }));
        }
    }, [
        provinceFormValues,
        map
    ]);
    (0,react.useEffect)(()=>{
        if (map && dealersData && dealersData.docs.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            dealersData.docs.forEach((dealer)=>{
                if (dealer.latitude && dealer.longitude) {
                    bounds.extend({
                        lat: dealer.latitude,
                        lng: dealer.longitude
                    });
                }
            });
            map.fitBounds(bounds);
        }
    }, [
        map,
        dealersData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "ตัวแทนจำหน่าย | แลมป์ตั้น"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        title: "ตัวแทนจำหน่าย"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleMobile/* default */.Z, {
                        children: "ตัวแทนจำหน่าย"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Container */.W2, {
                        pt: {
                            base: 8,
                            md: 12
                        },
                        pb: {
                            base: 8,
                            md: 20
                        },
                        children: [
                            dealerShopData && dealerShopData.docs.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                                        color: "primary.500",
                                        mb: 4,
                                        fontWeight: 400,
                                        children: "ห้างสรรพสินค้า"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                        mx: {
                                            base: -4,
                                            md: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                            mb: 6,
                                            p: 4,
                                            pr: {
                                                base: 0,
                                                md: 4
                                            },
                                            pb: 8,
                                            bg: "#EADFD0",
                                            position: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                    spaceBetween: 10,
                                                    slidesPerView: isDesktop ? 7 : isTablet ? 4.2 : 3.2,
                                                    onSlideChange: ()=>console.log("slide change"),
                                                    onSwiper: (swiper)=>console.log(swiper),
                                                    centeredSlides: false,
                                                    pagination: {
                                                        clickable: true,
                                                        el: ".my-swiper-pagination"
                                                    },
                                                    modules: [
                                                        swiper_esm/* Pagination */.tl
                                                    ],
                                                    className: "dealer-shop-swiper",
                                                    children: dealerShopData.docs.map((shop)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                                                                boxSize: "100px",
                                                                children: shop.websiteUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                                                                    href: "".concat(shop.websiteUrl),
                                                                    target: "_blank",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: "".concat("https://storage.lamptan.co.th", "/").concat(shop.logoPath),
                                                                        width: 100,
                                                                        height: 100,
                                                                        alt: shop.name
                                                                    })
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "".concat("https://storage.lamptan.co.th", "/").concat(shop.logoPath),
                                                                    width: 100,
                                                                    height: 100,
                                                                    alt: shop.name
                                                                })
                                                            })
                                                        }, shop.id))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                    position: "absolute",
                                                    bottom: 2,
                                                    left: "50% !important",
                                                    transform: "translateX(-50%)",
                                                    zIndex: "1",
                                                    columnGap: 1,
                                                    display: "flex",
                                                    width: "auto !important",
                                                    className: "my-swiper-pagination"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                                color: "primary.500",
                                mb: 4,
                                fontWeight: 400,
                                children: "ร้านค้าตัวแทนจำหน่าย"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                position: "relative",
                                children: [
                                    isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
                                        mapContainerStyle: {
                                            width: "100%",
                                            height: isDesktop ? "600px" : isTablet ? "400px" : "300px"
                                        },
                                        center: center,
                                        onLoad: onLoad,
                                        onUnmount: onUnmount,
                                        options: {
                                            mapTypeControl: false,
                                            streetViewControl: false,
                                            gestureHandling: "greedy"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: map && dealersData && dealersData.docs.length > 0 ? dealersData.docs.map((dealer)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_agent_AgentItemMarker, {
                                                    dealer: dealer,
                                                    onClick: ()=>{
                                                        map.setCenter({
                                                            lat: dealer.latitude,
                                                            lng: dealer.longitude
                                                        });
                                                        map.setZoom(14);
                                                    },
                                                    showInfoWindow: (currentDealer === null || currentDealer === void 0 ? void 0 : currentDealer.id) === dealer.id,
                                                    onInfoWindowClose: ()=>{
                                                        setCurrentDealer(null);
                                                    }
                                                }, dealer.id);
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                        position: {
                                            lg: "absolute"
                                        },
                                        top: "0",
                                        left: "0",
                                        height: "100%",
                                        boxShadow: "md",
                                        mt: {
                                            base: 6,
                                            lg: "0"
                                        },
                                        p: {
                                            lg: 4
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                            bg: "white",
                                            width: {
                                                base: "100%",
                                                lg: "300px"
                                            },
                                            display: "flex",
                                            flexDirection: "column",
                                            height: "100%",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                                                    bg: "#EADED0",
                                                    p: 4,
                                                    flex: "0 0 auto",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSelectGroup/* default */.Z, {
                                                                name: "region",
                                                                control: control,
                                                                rules: {
                                                                    required: "กรุณาเลือกภูมิภาค"
                                                                },
                                                                bg: "white",
                                                                options: dealerProvinces ? dealerProvinces.map((item)=>{
                                                                    var _regions_find;
                                                                    return {
                                                                        value: item.region,
                                                                        label: ((_regions_find = regions.find((region)=>region.value === item.region)) === null || _regions_find === void 0 ? void 0 : _regions_find.name) || ""
                                                                    };
                                                                }) : []
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSelectGroup/* default */.Z, {
                                                                name: "province",
                                                                control: control,
                                                                rules: {
                                                                    required: "กรุณาเลือกจังหวัด"
                                                                },
                                                                bg: "white",
                                                                options: currentRegionProvinces ? currentRegionProvinces.map((province)=>({
                                                                        value: province.id.toString(),
                                                                        label: province.name_th
                                                                    })) : [
                                                                    {
                                                                        value: "",
                                                                        label: ""
                                                                    }
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                    p: 4,
                                                    flex: "1",
                                                    overflowY: "auto",
                                                    children: (dealersData === null || dealersData === void 0 ? void 0 : dealersData.docs) && dealersData.docs.length > 0 ? dealersData.docs.map((dealer)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(pages_agent_AgentItem, {
                                                            dealer: dealer,
                                                            onClick: ()=>{
                                                                map === null || map === void 0 ? void 0 : map.setCenter({
                                                                    lat: dealer.latitude,
                                                                    lng: dealer.longitude
                                                                });
                                                                map === null || map === void 0 ? void 0 : map.setZoom(14);
                                                                setCurrentDealer(dealer);
                                                            }
                                                        }, dealer.id);
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                        children: "ไม่พบตัวแทนจำหน่าย"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
AgentPage.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootLayout/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var agent = (AgentPage);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,1255,8641,5675,1664,3863,4645,5359,1559,2077,2883,719,9806,9774,2888,179], function() { return __webpack_exec__(58362); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);